// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"q1-z","displaySixCardTiles":"r1-z"};